module.exports = {"title":{"en":"Verified","de":"Verifizierung erfolgreich","ro":"Verificare"},"verificationSuccess":{"en":"Successfully verified via SMS message confirmation","de":"Vielen Dank, Ihre Mobilfunknummer wurde erfolgreich verifiziert","ro":"Verificarea a fost efectuată cu succes prin SMS."},"buttonBackToApp":{"en":"Go Back to App","de":"Verifikation Beenden","ro":"Către Kaufland App\u0000"}}


//////////////////
// WEBPACK FOOTER
// ./src/localization/localization-verified.json
// module id = 109
// module chunks = 0